<ion-searchbar *ngIf="showSearch" class="ion-searchbar-custom info-text-mlg" [(ngModel)]="autocompleteQuery"
    showCancelButton="never" (ionInput)="onSearchInput($event)">
</ion-searchbar>

<div fxLayout="column">
    <!-- class="padding-s" -->
    <div>

        <div #mapContainer [class]="mapClass" [style.visibility]="!(loading || test) ? 'visible' : 'hidden'"
            [style.height]="!(loading || test) ? '' : '0'">

            <ion-fab *ngIf="showFab" vertical="top" horizontal="end" class="margin-top-fab">
                <ion-fab-button (click)="onFabClick()" class="round-fab round-fab-size button-color-primary-70">
                    <ion-icon name="search-outline"></ion-icon>
                </ion-fab-button>
            </ion-fab>
        </div>

        <div *ngIf="loading || test" class="progress-spinner-center">
            <mat-progress-spinner [diameter]="40" color="primary" mode="indeterminate"></mat-progress-spinner>
        </div>
    </div>
</div>